import AuthManager from 'crossasia-service-core/backend/auth'
import config from '../config'

const srv = new AuthManager(config.authTokenKey, config.authSrvApiUrl)

export default srv
